<template>
  <div>
    <section class="cart-section" style="padding:30px 0px 15px 0px;">
      <div  style="margin-bottom:10px">
        <form id="formSIF" v-on:submit.prevent="onSubmit">
          <div class="">
            <div class="padding-cls">
              <div class="checkout-page">
                <div class="checkout-form theme-form">
                  <div v-if="!sifInvalid" class="row center-content">
                    <div class="col-lg-12 col-sm-12 col-xs-12">
                      <div class="theme-card check-out ng-star-inserted">
                        <div class="row py-1">
                          <div class="col-md-6 px-5 py-2">
                            <button
  v-if="!sifComplete"
  class="btn btn-reload-outline"
  type="button"
  @click="reloadSIF"
  :class="{ 'loading': isReloading }"
>
  <i v-if="isReloading" class="fa fa-refresh fa-spin me-1"></i>
  <i v-else class="fa fa-refresh me-1"></i>
  <span>{{ isReloading ? 'Reloading...' : 'Reload' }}</span>
</button>


                          </div>
                          <div class="col-md-6">
                             <!-- <a v-if="sifComplete" class="btn btn-sm btn-outline-success radius-1 ml-2" target="_blank" style="float:right"  @click="printSIFCard"><i class="fa fa-print">&nbsp;</i>SIF</a> -->
                            <button v-if="sifComplete" class="btn btn-sm btn-xs btn-outline-success align-items-center p-2 ml-1"
                              @click="downloadSIF" :disabled="isDownloadingSIF" type="button"
                              >
                              <!-- Icon always visible, changes to spinner when downloading -->
                              <i :class="isDownloadingSIF ? 'fa fa-spinner fa-spin' : 'fa fa-download'"
                                aria-hidden="true" style="font-size: 1.2em;margin-right: 8px;"></i>

                              <!-- Message below icon -->
                              <span class="mt-1 text-center" style="font-size: 0.85rem;">
                                {{ isDownloadingSIF ? SIFProgress : 'Download SIF PDF' }}
                              </span>
                            </button>
                            
                            <button v-if="sifComplete" class="btn btn-sm btn-xs btn-outline-success align-items-center p-2 ml-2"
                              @click="downloadBankSlip" :disabled="isDownloadingBankSlip" type="button"
                              >
                              <!-- Icon always visible, changes to spinner when downloading -->
                              <i :class="isDownloadingBankSlip ? 'fa fa-spinner fa-spin' : 'fa fa-file-text-o'"
                                aria-hidden="true" style="font-size: 1.2em;margin-right: 8px;"></i>

                              <!-- Message below icon -->
                              <span class="mt-1 text-center" style="font-size: 0.85rem;">
                                {{ isDownloadingBankSlip ? BankSlipProgress : 'Download Bank Slip' }}
                              </span>
                            </button>
                            <!-- <a v-if="sifComplete" class="btn btn-sm btn-outline-success radius-1" target="_blank" style="float:right"  @click="printBankSlip"><i class="fa fa-file-text-o">&nbsp;</i>Bank Slip</a> -->
                          </div>
                        </div>
                        <div class="row responsive-center">
                          <div class="col-md-12 mb-4 mt-1" style="background:rgb(210, 210, 240);">
                            <h4  class="my-3 mx-0">
                              Admission Information 
                              <!--span v-if="sif_status=='Saved'" class="btn btn-sm btn-outline-secondary">{{sif_status}}</span>
                              <span v-if="sif_status=='Completed'" class="btn btn-sm btn-outline-success">{{sif_status}}</span>
                              <span v-if="sif_status=='Canceled'" class="btn btn-sm btn-outline-danger">{{sif_status}}</span-->
                            </h4>
                          </div>
                          <div class="form-group col-md-6 col-sm-12 col-xs-12 ">
                            <div class="field-label">Exam Roll (Unit)</div>
                            <input type="text" :value="sif.exam_roll+' ('+sif.unit+')'" disabled>
                          </div>
                          <div class="form-group col-md-6 col-sm-12 col-xs-12">
                            <div class="field-label">Quota</div>
                            <input type="text" class="ng-untouched ng-pristine ng-invalid" :value="sif.quota?sif.quota:'GENERAL'" disabled>
                          </div>
                          <div class="form-group col-md-12 col-sm-12 col-xs-12">
                            <div class="field-label">Assigned Subject</div>
                            <input type="text" class="ng-untouched ng-pristine ng-invalid" :value="sif.subject_name" disabled>
                          </div>
                          <hr/>
                          <!--div class="form-group col-md-6 col-sm-12 col-xs-12">
                            <div class="field-label">Course</div>
                            <input type="text" disabled placeholder="Name of the Course" class="ng-untouched ng-pristine ng-invalid" v-model="sif.course">
                          </div>
                          <div class="form-group col-md-6 col-sm-12 col-xs-12">
                            <div class="field-label">Session</div>
                            <input type="text" disabled placeholder="Academic Session" class="ng-untouched ng-pristine ng-invalid" v-model="sif.session">
                          </div>
                          <div class="form-group col-md-12 col-sm-12 col-xs-12">
                            <div class="field-label">Subject</div>
                            <input type="text" disabled placeholder="Name of the Department" class="ng-untouched ng-pristine ng-invalid" v-model="sif.subject">
                          </div>
                          <div class="form-group col-md-6 col-sm-12 col-xs-12">
                            <div class="field-label">Registration/ID No</div>
                            <input type="text" disabled placeholder="Registration/ID Number" class="ng-untouched ng-pristine ng-invalid" v-model="sif.regino">
                          </div>
                          <div class="form-group col-md-6 col-sm-12 col-xs-12">
                            <div class="field-label">Admission Roll</div>
                            <input type="text" disabled placeholder="Admission Roll" class="ng-untouched ng-pristine ng-invalid" v-model="sif.exam_roll">
                          </div>
                          <hr/>
                          <div class="form-group col-md-12 col-sm-12 col-xs-12">
                            <div class="field-label">Paid (Fee) Amount</div>
                            <input type="number" name="admission_fee" placeholder="Paid Amount" class="col-md-6 form-control input text ng-untouched ng-pristine ng-invalid" v-model="sif.admission_fee" disabled>
                          </div>
                          <div class="form-group col-md-6 col-sm-12 col-xs-12">
                            <div class="field-label">Payment Date</div>
                            <input type="date" name="payment_date" placeholder="Payment Date" class="form-control input text ng-untouched ng-pristine ng-invalid" v-model="sif.payment_date" :disabled="!sifEditable">
                          </div>
                          <div class="form-group col-md-6 col-sm-12 col-xs-12">
                            <div class="field-label">Memo/Receipt Number</div>
                            <input type="number" name="memo_receipt" placeholder="Memo/Receipt Number" class="form-control input text ng-untouched ng-pristine ng-invalid" v-model="sif.memo_receipt" disabled>
                          </div>
                          <hr/-->

                          <div class="form-group col-md-12 col-sm-12 col-xs-12">
                            <div class="field-label">Father's or Legal Guardian's Monthly Income (Salary, Business, Assets, etc)</div>
                            <input type="text" v-validate="sif.btn_action == 'submit' ? rules.guardian_income_number_submit : rules.guardian_income_number" name="guardian_income_number" placeholder="Income in Numbers" class="col-md-6 mb-2 form-control input text ng-untouched ng-pristine ng-invalid" v-model="sif.guardian_income_number" :disabled="!sifEditable" @change="sif.guardian_income_word=toWords(sif.guardian_income_number)" onkeypress="return event.charCode >= 48" min="1">
                            <span v-show="errors.has('guardian_income_number')" class="px-2 mt-1 is-danger">{{ errors.first('guardian_income_number') }}</span>  
                            <input type="text" v-validate="sif.btn_action == 'submit' ? rules.guardian_income_word_submit : rules.guardian_income_word" placeholder="Income in Words" class="col-md-12 form-control input text ng-untouched ng-pristine ng-invalid" v-model="sif.guardian_income_word" disabled style="text-transform: capitalize;">
                            <span v-show="errors.has('guardian_income_word')" class="px-2 mt-1 is-danger">{{ errors.first('guardian_income_word') }}</span>
                          </div>
                          <hr/>
                          
                          <div class="col-md-12 col-sm-12 col-xs-12 mb-2">
                            <div class="form-check" style="margin-left:0px; padding-left:0px;">
                              <label class="form-check-label" for="self_residence" style="margin-right: 30px;">Not stay in the univesity hall?
                              </label>
                              <input class="form-check-input"  :true-value="1" :false-value="0" v-validate="sif.btn_action == 'submit' ? rules.self_residence_submit : rules.self_residence" type="checkbox" id="self_residence" name="self_residence" value="sif.self_residence" v-model="sif.self_residence" :disabled="!sifEditable" @change="resetSelfResidence">
                              <label v-if="sif.self_residence" class="form-check-label" for="self_residence" style="float:right;"> (<span style="font-style:italic; color:red; text-transform:none;">Please fillup the following information</span>)</label>
                            </div>
                          </div>
                          <hr v-if="sif.self_residence" class="mt-1"/>
                          
                          <div v-if="sif.self_residence" class="form-group col-md-12 col-sm-12 col-xs-12" style="height:auto;">
                            <div class="field-label">Self-Residence Address (in English)</div>
                            <textarea style="min-height:80px;" v-validate="sif.self_residence ?sif.btn_action == 'submit' ? rules.residence_address_submit : rules.residence_address : ''" name="residence_address" placeholder="Address of Your Residence" class="ng-untouched ng-pristine ng-invalid" v-model="sif.residence_address" rows="3" autocomplete="off" :disabled="!sifEditable || !sif.self_residence"></textarea>
                            <span v-show="errors.has('residence_address')" class="px-2 mt-1 is-danger">{{ errors.first('residence_address') }}</span>
                            <div class="field-label mt-2">Contact Number (in English)</div>
                            <input type="text" v-validate="sif.self_residence ? sif.btn_action == 'submit' ? rules.residence_mobile_submit : rules.residence_mobile : ''" name="residence_mobile" placeholder="Telephone or Mobile Number" class="col-md-6 form-control input text ng-untouched ng-pristine ng-invalid" v-model="sif.residence_mobile" :disabled="!sifEditable || !sif.self_residence" onkeypress="return event.charCode >= 48" min="1">
                            <span v-show="errors.has('residence_mobile')" class="px-2 mt-1 is-danger">{{ errors.first('residence_mobile') }}</span>
                          </div>
                          
                          <hr v-if="sif.self_residence"/>
                          <div class="col-md-12 col-sm-12 col-xs-12">
                            <div class="form-check" style="margin-left:0px; padding-left:0px;">
                              <label class="form-check-label" for="interested_bncc" style="margin-right: 40px;">Are you interested to join BNCC or Rover-Scout?
                              </label>
                              <input class="form-check-input" :true-value="1" :false-value="0" v-validate="rules.interested_bncc" type="checkbox" id="interested_bncc" name="interested_bncc" value="sif.interested_bncc" v-model="sif.interested_bncc" :disabled="!sifEditable">
                            </div>
                          </div>
                        </div>

                        <div class="row responsive-center">
                          <div class="col-md-12 mb-4 mt-4" style="background:rgb(210, 210, 240);">
                            <h4 style="margin: 15px auto;">Applicant's Personal Information</h4>
                          </div>
                          
                          <div class="form-group col-md-12 col-sm-12 col-xs-12">
                            <div class="field-label">Applicant's Name (in Bangla)</div>
                            <input :class="{ 'is-blocked': errors.has('name_bng') }" v-validate="sif.btn_action == 'submit' ? rules.name_bng_submit : rules.name_bng" type="text" name="name_bng" placeholder="Applicant's Name in Bangla" class="ng-untouched ng-pristine ng-invalid bg-white" v-model="sif.name_bng" :disabled="!sifEditable">
                            <span v-show="errors.has('name_bng')" class="px-2 mt-1 is-danger">{{ errors.first('name_bng') }}</span>
                          </div>
                          <div class="form-group col-md-6 col-sm-12 col-xs-12">
                            <div class="field-label">Religion (in English)</div>
                            <select name="religion" v-model="sif.religion"  v-validate="sif.btn_action == 'submit' ? rules.religion_submit : rules.religion" class="ng-untouched ng-pristine ng-invalid" autocomplete="off" :disabled="!sifEditable">
                              <option value="" >Choose ... </option>
                              <option v-for="(value, key, index) in religions" v-bind:value="key">{{value}}</option>
                            </select>
                            <span v-show="errors.has('religion')" class="px-2 mt-1 is-danger">{{ errors.first('religion') }}</span>
                          </div>
                          <div class="form-group col-md-6 col-sm-12 col-xs-12">
                            <div class="field-label">Blood Group (in English)</div>
                            <select name="blood_group" v-model="sif.blood_group"  v-validate="sif.btn_action == 'submit' ? rules.blood_group_submit : rules.blood_group" class="ng-untouched ng-pristine ng-invalid" autocomplete="off" :disabled="!sifEditable">
                              <option value="">Choose ... </option>
                              <option v-for="(value, index) in blood_groups" v-bind:value="value">{{value}}</option>
                            </select>
                            <span v-show="errors.has('blood_group')" class="px-2 mt-1 is-danger">{{ errors.first('blood_group') }}</span>
                          </div>
                          <!--div class="form-group col-md-6 col-sm-12 col-xs-12">
                            <div class="field-label">Mobile Number</div>
                            <input type="number" name="mobile" placeholder="Applicant's Mobile Number" class="form-control input text ng-untouched ng-pristine ng-invalid" v-model="sif.mobile" :disabled="!sifEditable" onkeypress="return event.charCode >= 48" min="1">
                          </div-->
                          <div class="form-group col-md-6 col-sm-12 col-xs-12">
                            <div class="field-label">NID or Birth-Registration Number (in English)</div>
                            <input type="text" name="nid_brno" v-validate="sif.btn_action == 'submit' ? rules.nid_brno_submit : rules.nid_brno" placeholder="NID/Birth-Registration No" class="form-control input text ng-untouched ng-pristine ng-invalid" v-model="sif.nid_brno" :disabled="!sifEditable" onkeypress="return event.charCode >= 48" min="1">
                            <span v-show="errors.has('nid_brno')" class="px-2 mt-1 is-danger">{{ errors.first('nid_brno') }}</span>
                          </div>
                          <div class="form-group col-md-6 col-sm-12 col-xs-12">
                            <div class="field-label">Nationality (in English)</div>
                            <input type="text" name="nationality" v-validate="sif.btn_action == 'submit' ? rules.nationality_submit : rules.nationality" placeholder="Your nationality" class="form-control input text ng-untouched ng-pristine ng-invalid" v-model="sif.nationality" :disabled="1 || !sifEditable">
                          </div>
                          <hr/>
                          <div class="col-md-12 col-sm-12 col-xs-12">
                            <div class="form-check" style="margin-left:0px; padding-left:0px;">
                              <label class="form-check-label" for="is_married" style="margin-right: 40px;">Are you married?
                              </label>
                              <input class="form-check-input" :true-value="1" :false-value="0" v-validate="sif.btn_action == 'submit' ? rules.is_married_submit : rules.is_married" type="checkbox" id="is_married" name="is_married"  v-model="sif.is_married" :disabled="!sifEditable" @change="resetMaritalStatus">
                              <label v-if="sif.is_married" class="form-check-label" for="is_married" style="float:right;"> (<span style="font-style:italic; color:red; text-transform:none;">Please fillup the following information</span>)</label>
                              
                              
                            </div>
                          </div>
                          <hr v-if="sif.is_married" class="mt-2"/>
                          <div v-if="sif.is_married" class="form-group col-md-6 col-sm-12 col-xs-12">                            
                            <div class="field-label">Spouse's Name (in English)</div>
                            <input :class="{ 'is-blocked': errors.has('spouse_name') }" v-validate="sif.is_married ? sif.btn_action == 'submit' ? rules.spouse_name_submit : rules.spouse_name:''" type="text" name="spouse_name" placeholder="Your Spouse Name" class="form-control input text ng-untouched ng-pristine ng-invalid" v-model="sif.spouse_name" :disabled="!sifEditable || !sif.is_married">
                            <span v-show="errors.has('spouse_name')" class="help is-danger">{{ errors.first('spouse_name') }}</span>
                          </div>
                          <div v-if="sif.is_married" class="form-group col-md-6 col-sm-12 col-xs-12">
                            <div class="field-label">Spouse's Mobile Number (in English)</div>
                            <input type="text" v-validate="sif.is_married ? sif.btn_action == 'submit' ? rules.spouse_mobile_submit : rules.spouse_mobile:''" name="spouse_mobile" placeholder="Spouse's Mobile Number" class="form-control input text ng-untouched ng-pristine ng-invalid" v-model="sif.spouse_mobile" :disabled="!sifEditable || !sif.is_married" onkeypress="return event.charCode >= 48" min="1">
                            <span v-show="errors.has('spouse_mobile')" class="help is-danger">{{ errors.first('spouse_mobile') }}</span>
                          </div> 
                          <div v-if="sif.is_married" class="form-group col-md-12 col-sm-12 col-xs-12" style="height:auto;">
                            <div class="field-label">Spouse's Contact Address (in English)</div>
                            <textarea style="min-height:80px;" v-validate="sif.is_married ? sif.btn_action == 'submit' ? rules.spouse_address_submit : rules.spouse_address:''" name="spouse_address" placeholder="Spouse's Contact Address" class="ng-untouched ng-pristine ng-invalid" v-model="sif.spouse_address" rows="3" :disabled="!sifEditable || !sif.is_married"></textarea>
                            <span v-show="errors.has('spouse_address')" class="help is-danger">{{ errors.first('spouse_address') }}</span>
                          </div>
                        </div>

                        <div class="row responsive-center">
                          <div class="col-md-12 mb-4 mt-2" style="background:rgb(210, 210, 240);">
                            <h4 style="margin: 15px auto;">Parental's Information</h4>
                          </div>

                          <div class="form-group col-md-12 col-sm-12 col-xs-12">
                            <div class="field-label">Father's Name (in Bangla)</div>
                            <input type="text" v-validate="sif.btn_action == 'submit' ? rules.fname_bng_submit : rules.fname_bng" name="fname_bng" placeholder="Father's Name in Bangla" class="ng-untouched ng-pristine ng-invalid" v-model="sif.fname_bng" :disabled="!sifEditable">
                            <span v-show="errors.has('fname_bng')" class="px-2 mt-1 is-danger">{{ errors.first('fname_bng') }}</span>
                          </div>
                          <div class="form-group col-md-12 col-sm-12 col-xs-12">
                            <div class="field-label">Occupation (in English)</div>
                            <input type="text" name="foccupation" v-validate="sif.btn_action == 'submit' ? rules.foccupation_submit : rules.foccupation" placeholder="Father's Occupation" class="form-control input text ng-untouched ng-pristine ng-invalid" v-model="sif.foccupation" :disabled="!sifEditable">
                            <span v-show="errors.has('foccupation')" class="px-2 mt-1 is-danger">{{ errors.first('foccupation') }}</span>
                          </div>
                          <div class="form-group col-md-12 col-sm-12 col-xs-12">
                            <div class="field-label">Designation (in English)</div>
                            <input type="text" name="fdesignation" v-validate="sif.btn_action == 'submit' ? rules.fdesignation_submit : rules.fdesignation" placeholder="Father's Job Designation" class="form-control input text ng-untouched ng-pristine ng-invalid" v-model="sif.fdesignation" :disabled="!sifEditable">
                            <span v-show="errors.has('fdesignation')" class="px-2 mt-1 is-danger">{{ errors.first('fdesignation') }}</span>
                          </div>
                          <div class="form-group col-md-12 col-sm-12 col-xs-12" style="height:auto;">
                            <div class="field-label">Employer Information (Company Name & Address, in English)</div>
                            <textarea style="min-height:80px;" name="femployer_info" v-validate="sif.btn_action == 'submit' ? rules.femployer_info_submit : rules.femployer_info" placeholder="Company Detail Information" class="ng-untouched ng-pristine ng-invalid" v-model="sif.femployer_info" rows="3" :disabled="!sifEditable"></textarea>
                            <span v-show="errors.has('femployer_info')" class="px-2 mt-1 is-danger">{{ errors.first('femployer_info') }}</span>
                          </div>
                          <div class="form-group col-md-6 col-sm-12 col-xs-12">
                            <div class="field-label">NID or Birth-Registration Number (in English)</div>
                            <input type="text" name="fnid_brno" v-validate="sif.btn_action == 'submit' ? rules.fnid_brno_submit : rules.fnid_brno" placeholder="Father's NID/BR Number" class="form-control input text ng-untouched ng-pristine ng-invalid" v-model="sif.fnid_brno" :disabled="!sifEditable" onkeypress="return event.charCode >= 48" min="1" max="18">
                            <span v-show="errors.has('fnid_brno')" class="px-2 mt-1 is-danger">{{ errors.first('fnid_brno') }}</span>
                          </div>
                          <div class="form-group col-md-6 col-sm-12 col-xs-12">
                            <div class="field-label">Mobile Number (in English)</div>
                            <input type="text" name="fmobile" v-validate="sif.btn_action == 'submit' ? rules.fmobile_submit : rules.fmobile" placeholder="Father's Mobile Number" class="form-control input text ng-untouched ng-pristine ng-invalid" v-model="sif.fmobile" :disabled="!sifEditable" onkeypress="return event.charCode >= 48" min="1">
                            <span v-show="errors.has('fmobile')" class="px-2 mt-1 is-danger">{{ errors.first('fmobile') }}</span>
                          </div>
                          <hr/>
                          <div class="form-group col-md-12 col-sm-12 col-xs-12">
                            <div class="field-label">Mother's Name (in Bangla)</div>
                            <input type="text" v-validate="sif.btn_action == 'submit' ? rules.mname_bng_submit : rules.mname_bng" name="mname_bng" placeholder="Mother's Name in Bangla" class="ng-untouched ng-pristine ng-invalid" v-model="sif.mname_bng" :disabled="!sifEditable">
                            <span v-show="errors.has('mname_bng')" class="px-2 mt-1 is-danger">{{ errors.first('mname_bng') }}</span>
                          </div>
                          <div class="form-group col-md-6 col-sm-12 col-xs-12">
                            <div class="field-label">NID or Birth-Registration Number (in English)</div>
                            <input type="text" v-validate="sif.btn_action == 'submit' ? rules.mnid_brno_submit : rules.mnid_brno" name="mnid_brno" placeholder="Mother's NID/BR Number" class="form-control input text ng-untouched ng-pristine ng-invalid" v-model="sif.mnid_brno" :disabled="!sifEditable" onkeypress="return event.charCode >= 48" min="1">
                            <span v-show="errors.has('mnid_brno')" class="px-2 mt-1 is-danger">{{ errors.first('mnid_brno') }}</span>
                          </div>
                          <div class="form-group col-md-6 col-sm-12 col-xs-12">
                            <div class="field-label">Mobile Number (in English)</div>
                            <input type="text" name="mmobile" v-validate="sif.btn_action == 'submit' ? rules.mmobile_submit : rules.mmobile" placeholder="Mother's Mobile Number" class="form-control input text ng-untouched ng-pristine ng-invalid" v-model="sif.mmobile" :disabled="!sifEditable" onkeypress="return event.charCode >= 48" min="1">
                            <span v-show="errors.has('mmobile')" class="px-2 mt-1 is-danger">{{ errors.first('mmobile') }}</span>
                          </div>
                        </div>

                        <div class="row responsive-center">
                          <div class="col-md-12 mb-4 mt-1" style="background:rgb(210, 210, 240);">
                            <h4 style="margin: 15px auto;">Present Address</h4>
                          </div>

                          <div class="form-group col-md-12 col-sm-12 col-xs-12">
                            <div class="field-label">House (in English)</div>
                            <input type="text" name="present_house" v-validate="sif.btn_action == 'submit' ? rules.present_house_submit : rules.present_house" placeholder="Your Address Details" class="ng-untouched ng-pristine ng-invalid" v-model="sif.present_house" :disabled="!sifEditable">
                            <span v-show="errors.has('present_house')" class="px-2 mt-1 is-danger">{{ errors.first('present_house') }}</span>
                          </div>
                          
                          <div class="form-group col-md-12 col-sm-12 col-xs-12">
                            <div class="field-label">Village / Ward / Road (in English)</div>
                            <input type="text" name="present_village" v-validate="sif.btn_action == 'submit' ? rules.present_village_submit : rules.present_village" placeholder="Your Village/Ward Details" class="ng-untouched ng-pristine ng-invalid" v-model="sif.present_village" :disabled="!sifEditable">
                            <span v-show="errors.has('present_village')" class="px-2 mt-1 is-danger">{{ errors.first('present_village') }}</span>
                          </div>
                          <div class="form-group col-md-6 col-sm-12 col-xs-12">
                            <div class="field-label">District (in English)</div>
                            <select name="present_district" v-model="sif.present_district" v-validate="sif.btn_action == 'submit' ? rules.present_district_submit : rules.present_district" class="form-controll select ng-untouched ng-pristine ng-invalid" autocomplete="off" :disabled="!sifEditable" @change="onDistrictChange">
                              <option value="" >Choose ... </option>
                              <option v-for="(value, key, index) in districts" v-bind:value="key">{{value}}</option>
                            </select>
                            <span v-show="errors.has('present_district')" class="px-2 mt-1 is-danger">{{ errors.first('present_district') }}</span>
                          </div>
                          <div class="form-group col-md-6 col-sm-12 col-xs-12">
                            <div class="field-label">Contact Number (in English)</div>
                            <input type="text" name="present_mobile" v-validate="sif.btn_action == 'submit' ? rules.present_mobile_submit : rules.present_mobile" placeholder="Telephone or Mobile Number" class="ng-untouched ng-pristine ng-invalid" v-model="sif.present_mobile" :disabled="!sifEditable" onkeypress="return event.charCode >= 48" min="1">
                            <span v-show="errors.has('present_mobile')" class="px-2 mt-1 is-danger">{{ errors.first('present_mobile') }}</span>
                          </div>
                           <div class="form-group col-md-6 col-sm-12 col-xs-12">
                            <div class="field-label">Thana/Upozilla (in English)</div>                        

                            <select name="present_thana" v-model="sif.present_thana" v-validate="sif.btn_action == 'submit' ? rules.present_thana_submit : rules.present_thana" class="form-controll select ng-untouched ng-pristine ng-invalid" autocomplete="off" :disabled="!sifEditable" @change="onUpazillaChange">
                              <option value="">Choose ... </option>
                              <option v-for="(value, key, index) in filteredUpazillas" v-bind:value="key">{{value}}</option>
                            </select>
                            <span v-show="errors.has('present_thana')" class="px-2 mt-1 is-danger">{{ errors.first('present_thana') }}</span>
                          </div>
                          <div class="form-group col-md-6 col-sm-12 col-xs-12">
                            <div class="field-label">Post Office (in English)</div>                        

                            <select name="present_poffice" v-model="sif.present_poffice" v-validate="sif.btn_action == 'submit' ? rules.present_poffice_submit : rules.present_poffice" class="form-controll select ng-untouched ng-pristine ng-invalid" autocomplete="off" :disabled="!sifEditable">
                              <option value="">Choose ... </option>
                              <option v-for="(value, key, index) in filteredPostOffices" v-bind:value="key">{{value}}</option>
                            </select>

                            <span v-show="errors.has('present_poffice')" class="px-2 mt-1 is-danger">{{ errors.first('present_poffice') }}</span>
                          </div>
                         
                          
                        </div>

                        <div class="row responsive-center">
                          <div class="col-md-12 mb-4 mt-1" style="background:rgb(210, 210, 240);">
                            <h4 style="margin: 15px auto;">Permanent Address</h4>
                          </div>
                          
                          <div class="col-md-12 col-sm-12 col-xs-12">
                            <div class="form-check" style="margin-left:0px; padding-left:0px;">
                              <label class="form-check-label" for="both_address_same" style="margin-right: 40px;">Is permanent address same as present address?
                              </label>
                              <input class="form-check-input" :true-value="1" :false-value="0"  type="checkbox" v-validate="sif.btn_action == 'submit' ? rules.both_address_same_submit : rules.both_address_same" id="both_address_same" name="both_address_same" v-model="sif.both_address_same" @change="changePermanentAddressAsPresent" :disabled="!sifEditable" >
                              <!-- {{ sif.both_address_same }} -->
                            </div>

                            <hr v-if="!sif.both_address_same"/>
                          </div>

                          <div v-if="!sif.both_address_same" class="form-group col-md-12 col-sm-12 col-xs-12">
                            <div class="field-label">House (in English)</div>
                            <input type="text"  name="permanent_house" v-validate="sif.both_address_same == 0 ? sif.btn_action == 'submit' ? rules.permanent_house_submit : rules.permanent_house:''" placeholder="Your Address Details" class="ng-untouched ng-pristine ng-invalid" v-model="sif.permanent_house" :disabled="!sifEditable || sif.both_address_same > 0">
                            <span v-show="errors.has('permanent_house')" class="help is-danger">{{ errors.first('permanent_house') }}</span>
                          </div>

                          <div v-if="!sif.both_address_same" class="form-group col-md-12 col-sm-12 col-xs-12">
                            <div class="field-label">Village / Ward / Road (in English)</div>
                            <input type="text" v-validate="sif.both_address_same == 0 ? sif.btn_action == 'submit' ? rules.permanent_village_submit : rules.permanent_village:''" name="permanent_village" placeholder="Your Village/Ward Details" class="ng-untouched ng-pristine ng-invalid" v-model="sif.permanent_village" :disabled="!sifEditable || sif.both_address_same > 0">
                            <span v-show="errors.has('permanent_village')" class="help is-danger">{{ errors.first('permanent_village') }}</span>
                          </div>
                          <div v-if="!sif.both_address_same" class="form-group col-md-6 col-sm-12 col-xs-12">
                            <div class="field-label">District (in English)</div>
                            <select name="permanent_district" v-model="sif.permanent_district" v-validate="sif.both_address_same == 0 ? sif.btn_action == 'submit' ? rules.permanent_district_submit : rules.permanent_district:''"  class="form-controll select ng-untouched ng-pristine ng-invalid" autocomplete="off" :disabled="!sifEditable || sif.both_address_same > 0" @change="onDistrictChangePer">
                              <option value="">Choose ... </option>
                              <option v-for="(value, key, index) in districts" v-bind:value="key">{{value}}</option>
                            </select>
                            <span v-show="errors.has('permanent_district')" class="help is-danger">{{ errors.first('permanent_district') }}</span>
                          </div>
                          <div v-if="!sif.both_address_same" class="form-group col-md-6 col-sm-12 col-xs-12">
                            <div class="field-label">Contact Number (in English)</div>
                            <input type="text" name="permanent_mobile" v-validate="sif.both_address_same == 0 ? sif.btn_action == 'submit' ? rules.permanent_mobile_submit : rules.permanent_mobile:''" placeholder="Telephone or Mobile Number" class="ng-untouched ng-pristine ng-invalid" v-model="sif.permanent_mobile" :disabled="!sifEditable || sif.both_address_same > 0" onkeypress="return event.charCode >= 48" min="1">
                            <span v-show="errors.has('permanent_mobile')" class="help is-danger">{{ errors.first('permanent_mobile') }}</span>
                          </div>
                          
                          <div v-if="!sif.both_address_same" class="form-group col-md-6 col-sm-12 col-xs-12">
                            <div class="field-label">Thana/Upozilla (in English)</div>                           
                            <select name="permanent_thana" v-model="sif.permanent_thana" v-validate="sif.both_address_same == 0 ? sif.btn_action == 'submit' ? rules.permanent_thana_submit : rules.permanent_thana:''" class="form-controll select ng-untouched ng-pristine ng-invalid" autocomplete="off" :disabled="!sifEditable || sif.both_address_same > 0"
                             @change="onUpazillaChangePer"
                            >
                              <option value="">Choose ... </option>
                              <option v-for="(value, key, index) in filteredUpazillasPer" v-bind:value="key">{{value}}</option>
                            </select>
                            <span v-show="errors.has('permanent_thana')" class="help is-danger">{{ errors.first('permanent_thana') }}</span>
                          </div>

                          <div v-if="!sif.both_address_same" class="form-group col-md-6 col-sm-12 col-xs-12">
                            <div class="field-label">Post Office (in English)</div>                          
                            <select name="permanent_poffice" v-model="sif.permanent_poffice" v-validate="sif.both_address_same == 0 ? sif.btn_action == 'submit' ? rules.permanent_poffice_submit : rules.permanent_poffice:''" class="form-controll select ng-untouched ng-pristine ng-invalid" autocomplete="off" :disabled="!sifEditable || sif.both_address_same > 0">
                              <option value="">Choose ... </option>
                              <option v-for="(value, key, index) in filteredPostOfficesPer" v-bind:value="key">{{value}}</option>
                            </select>
                            <span v-show="errors.has('permanent_poffice')" class="help is-danger">{{ errors.first('permanent_poffice') }}</span>
                          </div>
                          
                        </div>

                        <div class="row responsive-center">
                          <div class="col-md-12 mb-4 mt-2" style="background:rgb(210, 210, 240);">
                            <h4 style="margin: 15px auto;">Local Guardian's Information</h4>
                          </div>
                          
                          <div class="form-group col-md-12 col-sm-12 col-xs-12">
                            <div class="field-label">Full Name (in English)</div>
                            <input type="text" name="guardian_name" v-validate="sif.btn_action == 'submit' ? rules.guardian_name_submit : rules.guardian_name" placeholder="Local Gurdian's Name" class="ng-untouched ng-pristine ng-invalid" v-model="sif.guardian_name" :disabled="!sifEditable">
                            <span v-show="errors.has('guardian_name')" class="help is-danger">{{ errors.first('guardian_name') }}</span>
                          </div>
                          <div class="form-group col-md-12 col-sm-12 col-xs-12">
                            <div class="field-label">Relation (in English)</div>
                            <input type="text" name="guardian_relation" v-validate="sif.btn_action == 'submit' ? rules.guardian_relation_submit : rules.guardian_relation" placeholder="Relation with Guardian" class="col-md-6 form-control input text ng-untouched ng-pristine ng-invalid" v-model="sif.guardian_relation" :disabled="!sifEditable">
                            <span v-show="errors.has('guardian_relation')" class="help is-danger">{{ errors.first('guardian_relation') }}</span>
                          </div>
                          <div class="form-group col-md-6 col-sm-12 col-xs-12">
                            <div class="field-label">NID or BR Number (in English)</div>
                            <input type="text" name="guardian_nid_brno" v-validate="sif.btn_action == 'submit' ? rules.guardian_nid_brno_submit : rules.guardian_nid_brno" placeholder="NID/Birth-Registration No" class="form-control input text ng-untouched ng-pristine ng-invalid" v-model="sif.guardian_nid_brno" :disabled="!sifEditable">
                            <span v-show="errors.has('guardian_nid_brno')" class="help is-danger">{{ errors.first('guardian_nid_brno') }}</span>
                          </div>
                          <div class="form-group col-md-6 col-sm-12 col-xs-12">
                            <div class="field-label">Telephone/Mobile Number (in English)</div>
                            <input type="text" name="guardian_mobile" v-validate="sif.btn_action == 'submit' ? rules.guardian_mobile_submit : rules.guardian_mobile" placeholder="Telephone/Mobile Number" class="form-control input text ng-untouched ng-pristine ng-invalid" v-model="sif.guardian_mobile" :disabled="!sifEditable" onkeypress="return event.charCode >= 48" min="1">
                            <span v-show="errors.has('guardian_mobile')" class="help is-danger">{{ errors.first('guardian_mobile') }}</span>
                          </div>
                          <div class="form-group col-md-12 col-sm-12 col-xs-12" style="height:auto;">
                            <div class="field-label">Contact Address (in English)</div>
                            <textarea style="min-height:80px;" name="guardian_address" v-validate="sif.btn_action == 'submit' ? rules.guardian_address_submit : rules.guardian_address" placeholder="Local Guardian's Address" class="ng-untouched ng-pristine ng-invalid" v-model="sif.guardian_address" rows="3" :disabled="!sifEditable"></textarea>
                            <span v-show="errors.has('guardian_address')" class="help is-danger">{{ errors.first('guardian_address') }}</span>
                          </div>
                        </div>

                        <div class="row responsive-center">
                          <div class="col-md-12 mb-4 mt-3" style="background:rgb(210, 210, 240);">
                            <h4 style="margin: 15px auto;">Academic Information</h4>
                          </div>
                          
                          <div class="form-group col-md-12 col-sm-12 col-xs-12">
                            <div class="field-label">Name of the School (SSC Level, in English)</div>
                            <input type="text" name="ssc_institute" v-validate="sif.btn_action == 'submit' ? rules.ssc_institute_submit : rules.ssc_institute" placeholder="Name of the SSC-Level Institute" class="ng-untouched ng-pristine ng-invalid" v-model="sif.ssc_institute" :disabled="!sifEditable">
                            <span v-show="errors.has('ssc_institute')" class="px-2 mt-1 is-danger">{{ errors.first('ssc_institute') }}</span>
                          </div>
                          <div class="form-group col-md-6 col-sm-12 col-xs-12">
                            <div class="field-label">Exam Center Code (SSC Level, in English)</div>
                            <input type="text" min="1" name="ssc_center" v-validate="sif.btn_action == 'submit' ? rules.ssc_center_submit : rules.ssc_center" placeholder="SSC Exam Center Code" class="ng-untouched ng-pristine ng-invalid" v-model="sif.ssc_center" :disabled="!sifEditable">
                            <span v-show="errors.has('ssc_center')" class="px-2 mt-1 is-danger">{{ errors.first('ssc_center') }}</span>
                          </div>
                          <div class="form-group col-md-12 col-sm-12 col-xs-12">
                            <div class="field-label">Name of the College (HSC Level, in English)</div>
                            <input type="text" name="hsc_institute" v-validate="sif.btn_action == 'submit' ? rules.hsc_institute_submit : rules.hsc_institute" placeholder="Name of the HSC-Level Institute" class="ng-untouched ng-pristine ng-invalid" v-model="sif.hsc_institute" :disabled="!sifEditable">
                            <span v-show="errors.has('hsc_institute')" class="px-2 mt-1 is-danger">{{ errors.first('hsc_institute') }}</span>
                          </div>
                          <div class="form-group col-md-6 col-sm-12 col-xs-12">
                            <div class="field-label">Exam Center Code (HSC Level, in English)</div>
                            <input type="text" min="1" name="hsc_center" v-validate="sif.btn_action == 'submit' ? rules.hsc_center_submit : rules.hsc_center" placeholder="HSC Exam Center Code" class="ng-untouched ng-pristine ng-invalid" v-model="sif.hsc_center" :disabled="!sifEditable">
                            <span v-show="errors.has('hsc_center')" class="px-2 mt-1 is-danger">{{ errors.first('hsc_center') }}</span>
                          </div>
                        </div>

                        <div class="row responsive-center">
                          <div class="col-md-12 mb-4 mt-4" style="background:rgb(210, 210, 240);">
                            <h4 style="margin: 15px auto;">Applicant's Employment Information</h4>
                          </div>

                          <div class="col-md-12 col-sm-12 col-xs-12">
                            <div class="form-check" style="margin-left:0px; padding-left:0px;">
                              <label class="form-check-label" for="is_employee" style="margin-right: 40px;">Are you an employee?
                              </label>
                              <input class="form-check-input" type="checkbox" :true-value="1" :false-value="0" v-validate="sif.btn_action == 'submit' ? rules.is_employee_submit : rules.is_employee" id="is_employee" name="is_employee" value="sif.is_employee" v-model="sif.is_employee" :disabled="!sifEditable" @change="resetEmploymentStatus">
                              <label v-if="sif.is_employee" class="form-check-label" for="is_employee" style="float:right;"> (<span style="font-style:italic; color:red; text-transform:none;">Please fillup the following information</span>)</label>
                            </div>
                          </div>
                          <hr v-if="sif.is_employee" class="mt-1"/>

                          <div v-if="sif.is_employee" class="form-group col-md-12 col-sm-12 col-xs-12">
                            <div class="field-label">Job Description (in English)</div>
                            <input type="text" v-validate="sif.is_employee ? sif.btn_action == 'submit' ? rules.job_description_submit : rules.job_description : ''" name="job_description" placeholder="Your Job Description" class="ng-untouched ng-pristine ng-invalid" v-model="sif.job_description" :disabled="!sifEditable || !sif.is_employee">
                            <span v-show="errors.has('job_description')" class="px-2 mt-1 is-danger">{{ errors.first('job_description') }}</span>
                            <div class="field-label mt-2">Employer Name & Designation (in English)</div>
                            <input type="text" v-validate="sif.is_employee ? sif.btn_action == 'submit' ? rules.employer_details_submit : rules.employer_details : ''" name="employer_details" placeholder="Employer's Information" class="ng-untouched ng-pristine ng-invalid" v-model="sif.employer_details" :disabled="!sifEditable || !sif.is_employee">
                            <span v-show="errors.has('employer_details')" class="px-2 mt-1 is-danger">{{ errors.first('employer_details') }}</span>
                            <div class="field-label mt-2">Employer Address (in English)</div>
                            <textarea style="min-height:80px;" v-validate="sif.is_employee ? sif.btn_action == 'submit' ? rules.employer_address_submit : rules.employer_address : ''" name="employer_address" placeholder="Employer's Address" class="ng-untouched ng-pristine ng-invalid" v-model="sif.employer_address" rows="3" autocomplete="off" :disabled="!sifEditable || !sif.is_employee"></textarea>
                            <span v-show="errors.has('employer_address')" class="px-2 mt-1 is-danger">{{ errors.first('employer_address') }}</span>
                          </div>
                        </div>

                        <div class="row responsive-center">
                          <div class="col-md-12 mb-4 mt-1" style="background:rgb(210, 210, 240);">
                            <h4 style="margin: 15px auto;">Previous Admission Information</h4>
                          </div>

                          <div class="col-md-12 col-sm-12 col-xs-12">
                            <div class="form-check" style="margin-left:0px; padding-left:0px;">
                              <label class="form-check-label" for="is_admitted" style="margin-right: 40px;">Had you admitted before?
                              </label>
                              <input class="form-check-input" :true-value="1" :false-value="0" v-validate="sif.btn_action == 'submit' ? rules.is_admitted_submit : rules.is_admitted" type="checkbox" id="is_admitted" name="is_admitted" value="sif.is_admitted" v-model="sif.is_admitted" :disabled="!sifEditable">
                              <label v-if="sif.is_admitted" class="form-check-label" for="is_admitted" style="float:right;"> (<span style="font-style:italic; color:red; text-transform:none;">Please fillup teh following information</span>)</label>
                            </div>
                          </div>
                          <hr v-if="sif.is_admitted" class="mt-2"/>
                          <div v-if="sif.is_admitted" class="form-group col-md-6 col-sm-12 col-xs-12">
                            
                            <div class="field-label">Course (in English)</div>
                            <input type="text" v-validate="sif.is_admitted ? sif.btn_action == 'submit' ? rules.admitted_course_submit : rules.admitted_course : ''" name="admitted_course" placeholder="Name of the Course" class="ng-untouched ng-pristine ng-invalid" v-model="sif.admitted_course" :disabled="!sifEditable || !sif.is_admitted">
                            <span v-show="errors.has('admitted_course')" class="px-2 mt-1 is-danger">{{ errors.first('admitted_course') }}</span>
                          </div>
                          <div v-if="sif.is_admitted" class="form-group col-md-6 col-sm-12 col-xs-12">
                            <div class="field-label">Session (in English)</div>
                            <input type="text" name="admitted_session" v-validate="sif.is_admitted ? sif.btn_action == 'submit' ? rules.admitted_session_submit : rules.admitted_session : ''" placeholder="e.g., 2024-2025" class="ng-untouched ng-pristine ng-invalid" v-model="sif.admitted_session" :disabled="!sifEditable || !sif.is_admitted">
                            <span v-show="errors.has('admitted_session')" class="px-2 mt-1 is-danger">{{ errors.first('admitted_session') }}</span>
                          </div>
                          <div v-if="sif.is_admitted" class="form-group col-md-12 col-sm-12 col-xs-12">
                            <div class="field-label">Subject (in English)</div>
                            <input type="text" v-validate="sif.is_admitted ? sif.btn_action == 'submit' ? rules.admitted_subject_submit : rules.admitted_subject : ''" name="admitted_subject" placeholder="Name of the Department" class="ng-untouched ng-pristine ng-invalid" v-model="sif.admitted_subject" :disabled="!sifEditable || !sif.is_admitted">
                            <span v-show="errors.has('admitted_subject')" class="px-2 mt-1 is-danger">{{ errors.first('admitted_subject') }}</span>
                          </div>
                          <div v-if="sif.is_admitted" class="form-group col-md-12 col-sm-12 col-xs-12">
                            <div class="field-label">Name of the Institute (in English)</div>
                            <input type="text" v-validate="sif.is_admitted ? sif.btn_action == 'submit' ? rules.admitted_institute_submit : rules.admitted_institute : ''" name="admitted_institute" placeholder="Name of the Institute" class="ng-untouched ng-pristine ng-invalid" v-model="sif.admitted_institute" :disabled="!sifEditable || !sif.is_admitted">
                            <span v-show="errors.has('admitted_institute')" class="px-2 mt-1 is-danger">{{ errors.first('admitted_institute') }}</span>
                          </div>
                          <div v-if="sif.is_admitted" class="form-group col-md-6 col-sm-12 col-xs-12">
                            <div class="field-label">Registration/ID No (in English)</div>
                            <input type="text" v-validate="sif.is_admitted ? sif.btn_action == 'submit' ? rules.admitted_regino_submit : rules.admitted_regino : ''" name="admitted_regino" placeholder="Registration/ID Number" class="ng-untouched ng-pristine ng-invalid" v-model="sif.admitted_regino" :disabled="!sifEditable || !sif.is_admitted" onkeypress="return event.charCode >= 48" min="1">
                            <span v-show="errors.has('admitted_regino')" class="px-2 mt-1 is-danger">{{ errors.first('admitted_regino') }}</span>
                          </div>
                          <div v-if="sif.is_admitted" class="form-group col-md-6 col-sm-12 col-xs-12">
                            <div class="field-label">Class Roll (in English)</div>
                            <input type="text" v-validate="sif.is_admitted ? sif.btn_action == 'submit' ? rules.admitted_classroll_submit : rules.admitted_classroll : ''" name="admitted_classroll"  placeholder="Class Roll" class="ng-untouched ng-pristine ng-invalid" v-model="sif.admitted_classroll" :disabled="!sifEditable || !sif.is_admitted" onkeypress="return event.charCode >= 48" min="1">
                            <span v-show="errors.has('admitted_classroll')" class="px-2 mt-1 is-danger">{{ errors.first('admitted_classroll') }}</span>
                          </div>

                          <hr v-if="sif.is_admitted"/>
                          <div class="col-md-12 col-sm-12 col-xs-12 mt-2">
                            <div class="form-check" style="margin-left:0px; padding-left:0px;">
                              <label class="form-check-label" for="is_postponed" style="margin-right: 40px;">Had your study postponed?
                              </label>
                              <input class="form-check-input" v-validate="sif.btn_action == 'submit' ? rules.is_postponed_submit : rules.is_postponed" :true-value="1" :false-value="0" type="checkbox" id="is_postponed" name="is_postponed" value="sif.is_postponed" v-model="sif.is_postponed" :disabled="!sifEditable">
                              <label v-if="sif.is_postponed" class="form-check-label" for="is_postponed" style="float:right;"> (<span style="font-style:italic; color:red; text-transform:none;">Please specify the reason</span>)</label>
                            </div>
                          </div>
                          <hr v-if="sif.is_postponed" class="mt-2"/>
                          <div v-if="sif.is_postponed" class="form-group col-md-12 col-sm-12 col-xs-12" style="height:auto;">
                            <div class="field-label">Specify the Reason (in English)</div>
                            <textarea style="min-height:80px;" v-validate="sif.is_postponed ? sif.btn_action == 'submit' ? rules.postponed_reason_submit : rules.postponed_reason : ''" name="postponed_reason" placeholder="Specify the reason" class="ng-untouched ng-pristine ng-invalid" v-model="sif.postponed_reason" rows="3" autocomplete="off" :disabled="!sifEditable || !sif.is_postponed"></textarea>
                            <span v-show="errors.has('postponed_reason')" class="px-2 mt-1 is-danger">{{ errors.first('postponed_reason') }}</span>
                          </div>
                          <hr v-if="sif.is_postponed"/>
                          <div class="col-md-12 col-sm-12 col-xs-12 mt-2">
                            <div class="form-check" style="margin-left:0px; padding-left:0px;">
                              <label class="form-check-label" for="is_expeled" style="margin-right: 40px;">Had you expelled?
                              </label>
                              <input class="form-check-input" :true-value="1" :false-value="0" v-validate="sif.btn_action == 'submit' ? rules.is_expeled_submit : rules.is_expeled" type="checkbox" id="is_expeled" name="is_expeled" value="sif.is_expeled" v-model="sif.is_expeled" :disabled="!sifEditable">
                              <label v-if="sif.is_expeled" class="form-check-label" for="is_expeled" style="float: right;"> (<span style="font-style:italic; color:red; text-transform:none;">Please fillup the following information</span>)</label>
                            </div>
                          </div>
                          <hr v-if="sif.is_expeled" class="mt-2"/>
                          <div v-if="sif.is_expeled" class="form-group col-md-12 col-sm-12 col-xs-12" style="height:auto;">
                            <div class="field-label">Specify the Reason (in English)</div>
                            <textarea style="min-height:80px;" v-validate="sif.is_expeled ? sif.btn_action == 'submit' ? rules.expeled_reason_submit : rules.expeled_reason : ''" name="expeled_reason" placeholder="Specify the reason" class="ng-untouched ng-pristine ng-invalid" v-model="sif.expeled_reason" rows="3" autocomplete="off" :disabled="!sifEditable || !sif.is_expeled"></textarea>
                            <span v-show="errors.has('expeled_reason')" class="px-2 mt-1 is-danger">{{ errors.first('expeled_reason') }}</span>
                          </div>
                          <div v-if="sif.is_expeled" class="form-group col-md-12 col-sm-12 col-xs-12" style="height:auto;">
                            <div class="field-label">Expeled Period (Months, in English)</div>
                            <input type="text" name="expeled_period" v-validate="sif.is_expeled ? sif.btn_action == 'submit' ? rules.expeled_period_submit : rules.expeled_period : ''" placeholder="Months" class="col-md-6 ng-untouched ng-pristine ng-invalid" v-model="sif.expeled_period" :disabled="!sifEditable || !sif.is_expeled" onkeypress="return event.charCode >= 48" min="1">
                            <span v-show="errors.has('expeled_period')" class="px-2 mt-1 is-danger">{{ errors.first('expeled_period') }}</span>
                          </div>
                          <div v-if="sif.is_expeled" class="form-group col-md-12 col-sm-12 col-xs-12" style="height:auto;">
                            <div class="field-label">Name of the Institute (in English)</div>
                            <input type="text" name="expeled_institute" v-validate="sif.is_expeled ? sif.btn_action == 'submit' ? rules.expeled_institute_submit : rules.expeled_institute : ''" placeholder="Name of the Institute" class="ng-untouched ng-pristine ng-invalid" v-model="sif.expeled_institute" :disabled="!sifEditable || !sif.is_expeled">
                            <span v-show="errors.has('expeled_institute')" class="px-2 mt-1 is-danger">{{ errors.first('expeled_institute') }}</span>
                          </div>
                          <div v-if="sif.is_expeled" class="form-group col-md-12 col-sm-12 col-xs-12" style="height:auto;">
                            <div class="field-label">If you expeled due to unfair means in exam, then specify the Exam Name, Subject, Exam Year, Exam Roll, etc (in English)</div>
                            <textarea style="min-height:80px;" name="expeled_examinfo" v-validate="sif.is_expeled ? sif.btn_action == 'submit' ? rules.expeled_examinfo_submit : rules.expeled_examinfo : ''" placeholder="Specify the Exam Name, Exam Year, Exam Roll, Name of the Subject" class="ng-untouched ng-pristine ng-invalid" v-model="sif.expeled_examinfo" rows="3" autocomplete="off" :disabled="!sifEditable || !sif.is_expeled"></textarea>
                            <span v-show="errors.has('expeled_examinfo')" class="px-2 mt-1 is-danger">{{ errors.first('expeled_examinfo') }}</span>
                          </div>
                          <hr v-if="sif.is_expeled"/>
                          <div class="col-md-12 col-sm-12 col-xs-12">
                            <div class="form-check" style="margin-left:0px; padding-left:0px;">
                              <label class="form-check-label" for="is_readmitted" style="margin-right: 40px;">Had you re-admitted?
                              </label>
                              <input class="form-check-input" :true-value="1" :false-value="0" v-validate="sif.btn_action == 'submit' ? rules.is_readmitted_submit : rules.is_readmitted" type="checkbox" id="is_readmitted" name="is_readmitted" value="sif.is_readmitted" v-model="sif.is_readmitted" :disabled="!sifEditable">
                              <label v-if="sif.is_readmitted" class="form-check-label" for="is_readmitted" style="float: right;"> (<span style="font-style:italic; color:red; text-transform:none;">Specify the reason</span>)</label>
                            </div>
                          </div>
                          <hr v-if="sif.is_readmitted" class="mt-2"/>
                          <div v-if="sif.is_readmitted" class="form-group col-md-12 col-sm-12 col-xs-12" style="height:auto;">
                            <div class="field-label">Specify the Reason (in English)</div>
                            <textarea style="min-height:80px;" v-validate="sif.is_readmitted ? sif.btn_action == 'submit' ? rules.readmission_reason_submit : rules.readmission_reason : ''" name="readmission_reason" placeholder="Specify the reason" class="ng-untouched ng-pristine ng-invalid" v-model="sif.readmission_reason" rows="3" autocomplete="off" :disabled="!sifEditable || !sif.is_readmitted"></textarea>
                            <span v-show="errors.has('readmission_reason')" class="px-2 mt-1 is-danger">{{ errors.first('readmission_reason') }}</span>
                          </div>
                        </div>

                        <div class="row px-2 py-2 mt-4">
                          <hr v-if="missingError"/>
                          <div v-if="missingError" class="cold-md-12 p-2 alert-danger">{{missingMsg}}</div>

                            <div v-if="errors.any()" class="p-1">
                              <ul class="alert alert-danger" style="padding:10px; margin-top:10px;">
                                <li class="py-1" v-for="(error, index) in errors.all()" :key="index">
                                  {{ error }}
                                </li>
                              </ul>
                            </div>
                        </div>
                        <div class="row px-2 py-2">
                          <hr class="mb-4"/>
                          <input type="hidden" name="btn_action" v-model="sif.btn_action">
                          <div class="col-md-12 col-sm-12 col-xs-12">
                            <button style="margin-right:10px;margin-top:10px;" class="btn info-btn btn-info radius-1" type="submit" @click="sif.btn_action='save'" :disabled="!sifEditable || sifComplete"><i v-if="isSaving" class="fa fa-spinner fa-spin mr-2"></i>Save SIF</button>
                            <button style="margin-top:10px; float:right" class="btn success-btn btn-success radius-1" type="submit" @click="sif.btn_action='submit'" :disabled="!sifEditable || sifComplete"><i v-if="isSubmiting" class="fa fa-spinner fa-spin mr-2">&nbsp;</i>Submit SIF</button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </section>
  </div>
</template>

<script>
import Loader from '@/components/Helper/Loader'
import { GET_SIF, POST_SIF, POST_SIF_NEW } from '@/const/api'
import { GET, POST } from '@/utils/Request'
import moment from 'moment'

import districts from "@/geo-data/bd_district_kv.json";
import upazillas from "@/geo-data/bd_upazilla_thana_kv.json";
import postOffices from "@/geo-data/bd_upazilla_thana_post_office_kv_pcode.json";

import { registerCustomVeeRules } from '@/utils/veeValidationSetup';
import { validationRules } from '@/utils/sif/validationRules';
import { rules } from 'eslint-config-prettier';

import SifGenerator from "@/utils/SifGenerator";
import BankSlipGenerator from "@/utils/BankSlipGenerator";

export default {
  name: 'ProfileSif',
  components: { Loader },
  data() {
    return {
      
      missingMsg : '',
      missingError : false,
      sifInvalid : true,
      sifEditable : false,
      sifComplete : false,
      isReloading : false,
      isSaving: false,
      isSubmiting: false,

      sif_status : '',

      districts,               // all districts
      upazillas,               // all upazillas keyed by district
      postOffices,             // all post offices keyed by upazilla

      sif:{
        exam_roll : '',
        quota : '',
        unit: '',
        subject : '',
        subject_name : '',
        btn_action : '',
        admission_status : '',

        name_bng : '',
        religion : '',
        nationality : '',
        mobile : '',
        nid_brno : '',
        nationality : 'Bangladeshi',
        is_married : 0,
        spouse_name : '',
        spouse_address : '',
        spouse_mobile : '',
        is_employee : 0,
        job_description : '',
        employer_details : '',
        employer_address : '',
        
        fname_bng : '',
        foccupation : '',
        fdesignation : '',
        femployer_info : '',
        fnid_brno : '',
        fmobile : '',
        mname_bng : '',
        mnid_brno : '',
        mmobile : '',
        
        present_house : '',
        present_vilage : '',
        present_poffice : '',
        present_thana : '',
        present_district : '',
        present_mobile : '',
        both_address_same : 0,
        permanent_house : '',
        permanent_vilage : '',
        permanent_poffice : '',
        permanent_thana : '',
        permanent_district : '',
        permanent_mobile : '',
        
        guardian_name : '',
        guardian_relation : '',
        guardian_nid_brno : '',
        guardian_mobile : '',
        guardian_address : '',
        
        ssc_institute : '',
        ssc_center : '',
        hsc_institute : '',
        hsc_center : '',
        
        admission_fee : '',
        payment_date : '',
        memo_receipt : '',
        interested_bncc : 0,
        guardian_income_number : '',
        guardian_income_word : '',
        self_residence : 0,
        residence_address : '',
        residence_mobile: '',

        is_admitted : 0,
        admitted_institute : '',
        admitted_course : '',
        admitted_subject : '',
        admitted_session : '',
        admitted_classroll : '',
        admitted_regino : '',
        is_postponed : 0,
        postponed_reason : '',
        is_expeled : 0,
        expeled_reason : '',
        expeled_institute : '',
        expeled_period : '',
        expeled_examinfo : '',
        is_readmitted : 0,
        readmission_reason : '',
      },
      religions: {
        Islam: 'Islam',
        Hindu: 'Hindu',
        Buddho: 'Buddho',
        Christian: 'Christian',
        Other: 'Other'
      },
      genders: {
        Male: 'Male',
        Female: 'Female',
        Other: 'Other'
      },
      
      maritals: {
        Single: "Single",
        Married: "Married",
        Divorced: "Divorced",
        Widowed: "Widowed"
      },

      blood_groups : [ "A+", "A-", "B+", "B-", "AB+", "AB-", "O+", "O-"],

      rules: validationRules,

      isDownloadingSIF:false,
      SIFProgress: 'Preparing...',
      
      isDownloadingBankSlip: false,
      BankSlipProgress: 'Preparing...',

      isDownloadingBankSlip: false,
      BankSlipProgress: 'Preparing...',

    }
  },

  computed: {
    filteredUpazillas() {
      return this.upazillas[this.sif.present_district] || {};
    },
    filteredPostOffices() {
      return this.postOffices[this.sif.present_thana] || {};
    },
    filteredUpazillasPer() {
      return this.upazillas[this.sif.permanent_district] || {};
    },
    filteredPostOfficesPer() {
      return this.postOffices[this.sif.permanent_thana] || {};
    },

    
  },
  created() {
    this.getSIF();
    registerCustomVeeRules(); // just register the rules
  },
  
  methods: {

    onDistrictChange() {
      this.sif.present_thana = "";
      this.sif.present_poffice = "";
    },
    onDistrictChangePer() {
      this.sif.permanent_thana = "";
      this.sif.permanent_poffice = "";
    },
    onUpazillaChange() {
      this.sif.present_poffice = "";
    },

    onUpazillaChangePer() {
      this.sif.permanent_poffice = "";
    },
  
    changePermanentAddressAsPresent(){

      if(this.sif.both_address_same) {
        this.sif.permanent_house = this.sif.present_house;
        this.sif.permanent_village = this.sif.present_village;
        this.sif.permanent_poffice = this.sif.present_poffice;
        this.sif.permanent_thana = this.sif.present_thana;
        this.sif.permanent_district = this.sif.present_district;
        this.sif.permanent_mobile = this.sif.present_mobile;
      }
    },

    resetMaritalStatus() {
      if(!this.sif.is_married) {
        this.sif.spouse_name = null;
        this.sif.spouse_mobile = null;
        this.sif.spouse_address = null;
      }
    },

    resetEmploymentStatus() {
      if(!this.sif.is_employee) {
        this.sif.job_description = null;
        this.sif.employer_details = null;
        this.sif.employer_address = null;
      }
    },

    resetSelfResidence() {
      if(!this.sif.self_residence) {
        this.sif.residence_mobile = '';
        this.sif.residence_address = '';
      }
    },

    reloadSIF() {
      this.getSIF();
    },

    printSIFCard() {
      window.open('/print-sif', '_blank');
    },

    printBankSlip() {
      window.open('/bank-slip', '_blank');
    },

    async downloadBankSlip() {
      if (this.isDownloadingBankSlip) {
        return
      }

      this.isDownloadingBankSlip = true
      this.BankSlipProgress = 'Preparing...'

      try {
        await BankSlipGenerator.generateBankSlip(
          (message, progress) => {
            this.BankSlipProgress = message
          },
          (error) => {
            console.error('Bank Slip generation error:', error)
            this.$iziToast.error({
              title: 'Error',
              message: error.message || 'Failed to generate Bank Slip. Please try again.'
            })
          }
        )

        // Success notification
        this.$iziToast.success({
          title: 'Success',
          message: 'Bank Slip downloaded successfully!'
        })
      } catch (error) {
        console.error('Bank Slip download error:', error)
        this.$iziToast.error({
          title: 'Error',
          message: error.message || 'Failed to download Bank Slip. Please try again.'
        })
      } finally {
        this.isDownloadingBankSlip = false
        this.BankSlipProgress = 'Preparing...'
      }
    },

    async getSIF(){

      this.isReloading = true;
      var data = await GET(GET_SIF);
      this.isReloading = false;
      
      this.sifInvalid = true;
      this.sifEditable = false;
      this.sifComplete = false;

      // console.log('getSIF', data.data);

      if(data.data.status != 'success') 
      {
        if(data.data.msg)
        {
          this.$iziToast.error({message: data.data.msg});
        }
        else if(data.data.message)
        {
          /*this.$iziToast.error({message: data.data.message});*/
        }
        else
        {
          this.$iziToast.error({message: 'Something went wrong!!!'});
        }
        return false;
      }
      else
      {
        this.sifInvalid = data.data.sifInvalid;
        this.sifComplete = data.data.sifComplete;
        this.sifEditable = data.data.sifEditable;

        this.sif.unit = data.data.data.unit;
        this.sif.quota = data.data.data.quota;
        this.sif.exam_roll = data.data.data.exam_roll;
        this.sif.subject = data.data.data.subject;
        this.sif.subject_name = data.data.data.subject_name;
        this.sif.admission_status = data.data.data.admission_status;
        
        this.sif_status = this.admission_status=='3_cancel' ? 'Canceled' : (this.admission_status=='2_submit' ? 'Completed' : (this.sif_status!='0_initial' ? 'Saved' : ''));

        this.sif.name_bng = data.data.data.name_bng;
        this.sif.religion = data.data.data.religion;
        this.sif.gender = data.data.data.gender;
        this.sif.blood_group = data.data.data.blood_group;
        this.sif.mobile = data.data.data.mobile;
        this.sif.nid_brno = data.data.data.nid_brno;
        this.sif.nationality = data.data.data.nationality;
        this.sif.is_married = data.data.data.is_married;
        this.sif.spouse_name = data.data.data.spouse_name;
        this.sif.spouse_mobile = data.data.data.spouse_mobile;
        this.sif.spouse_address = data.data.data.spouse_address;
        
        this.sif.fname_bng = data.data.data.fname_bng;
        this.sif.foccupation = data.data.data.foccupation;
        this.sif.fdesignation = data.data.data.fdesignation;
        this.sif.femployer_info = data.data.data.femployer_info;
        this.sif.fnid_brno = data.data.data.fnid_brno;
        this.sif.fmobile = data.data.data.fmobile;

        this.sif.mname_bng = data.data.data.mname_bng;
        this.sif.mnid_brno = data.data.data.mnid_brno;
        this.sif.mmobile = data.data.data.mmobile;

        this.sif.present_house = data.data.data.present_house;
        this.sif.present_village = data.data.data.present_village;
        this.sif.present_poffice = data.data.data.present_poffice;
        this.sif.present_thana = data.data.data.present_thana;
        this.sif.present_district = data.data.data.present_district;
        this.sif.present_mobile = data.data.data.present_mobile;
        this.sif.both_address_same = data.data.data.both_address_same;

        this.sif.permanent_house = data.data.data.permanent_house;
        this.sif.permanent_village = data.data.data.permanent_village;
        this.sif.permanent_poffice = data.data.data.permanent_poffice;
        this.sif.permanent_thana = data.data.data.permanent_thana;
        this.sif.permanent_district = data.data.data.permanent_district;
        this.sif.permanent_mobile = data.data.data.permanent_mobile;
        
        this.sif.guardian_name = data.data.data.guardian_name;
        this.sif.guardian_relation = data.data.data.guardian_relation;
        this.sif.guardian_address = data.data.data.guardian_address;
        this.sif.guardian_nid_brno = data.data.data.guardian_nid_brno;
        this.sif.guardian_mobile = data.data.data.guardian_mobile;
        
        this.sif.ssc_institute = data.data.data.ssc_institute;
        this.sif.hsc_institute = data.data.data.hsc_institute;
        this.sif.ssc_center = data.data.data.ssc_center;
        this.sif.hsc_center = data.data.data.hsc_center;
        
        this.sif.admission_fee = data.data.data.admission_fee;
        this.sif.payment_date = data.data.data.payment_date;
        this.sif.memo_receipt = data.data.data.memo_receipt;
        this.sif.guardian_income_number = data.data.data.guardian_income_number;
        this.sif.guardian_income_word = data.data.data.guardian_income_word;
        this.sif.self_residence = data.data.data.self_residence;
        this.sif.residence_address = data.data.data.residence_address;
        this.sif.residence_mobile = data.data.data.residence_mobile;
        this.sif.interested_bncc = data.data.data.interested_bncc;

        this.sif.is_employee = data.data.data.is_employee;
        this.sif.job_description = data.data.data.job_description;
        this.sif.employer_details = data.data.data.employer_details;
        this.sif.employer_address = data.data.data.employer_address;

        this.sif.is_admitted = data.data.data.is_admitted;
        this.sif.admitted_course = data.data.data.admitted_course;
        this.sif.admitted_session = data.data.data.admitted_session;
        this.sif.admitted_subject = data.data.data.admitted_subject;
        this.sif.admitted_institute = data.data.data.admitted_institute;
        this.sif.admitted_regino = data.data.data.admitted_regino;
        this.sif.admitted_classroll = data.data.data.admitted_classroll;
        this.sif.is_postponed = data.data.data.is_postponed;
        this.sif.postponed_reason = data.data.data.postponed_reason;
        this.sif.is_expeled = data.data.data.is_expeled;
        this.sif.expeled_reason = data.data.data.expeled_reason;
        this.sif.expeled_institute = data.data.data.expeled_institute;
        this.sif.expeled_period = data.data.data.expeled_period;
        this.sif.expeled_examinfo = data.data.data.expeled_examinfo;
        this.sif.is_readmitted = data.data.data.is_readmitted;
        this.sif.readmission_reason = data.data.data.readmission_reason;
      }
    },

    async onSubmit(){
      
      const valid = await this.$validator.validateAll()

      const values = {}

      await this.$validator.fields.items.forEach(f => {
        values[f.name] = f.value
      })

      console.log(values)

      if (!valid) {
        this.$iziToast.error({ message: 'Please Check the errors in the form' })
        return   // ⛔ STOP HERE
      }
      this.sif.btn_action=='save' ? this.isSaving = true : this.isSubmiting = true;
      
      let response = await POST(POST_SIF_NEW, this.sif);

      /*let response = await POST(POST_SIF, this.sif);*/
      this.isSaving = this.isSubmiting = false;

      // console.log(response);

      this.missingError = false;
      this.missingMsg = '';

      

      if(response.status=='200'){
        let type = response.data.status;
        if(type=='success')
        {
          let msg = response.data.message;
          
          // Instantly disable buttons after successful submission
          if(this.sif.btn_action=='submit') {
            this.sifEditable = false;
            this.sifComplete = true;
          }
          
          this.getSIF();
          this.$iziToast.success({message: msg});
        }
        else
        {
          let msg = response.data.message;
          if(type=='info')
          {
            this.$iziToast.info({message: msg});
          }
          /*
          else if(type=='missing')
          {
            this.missingError = true;
            this.missingMsg = response.data.message;
          } 
          */
          else
          {
              this.$iziToast.error({message: msg});
          }
        }
      }
    },

    formatDate() {
      if (this.sif.payment_date) {
        this.sif.payment_date = moment(String(this.sif.payment_date)).format('dd/mm/yyyy');
      }
    },

    toWords(s) {
      
      var th_val = ['', 'thousand', 'million', 'billion', 'trillion'];
      var dg_val = ['zero', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine'];
      var tn_val = ['ten', 'eleven', 'twelve', 'thirteen', 'fourteen', 'fifteen', 'sixteen', 'seventeen', 'eighteen', 'nineteen'];
      var tw_val = ['twenty', 'thirty', 'forty', 'fifty', 'sixty', 'seventy', 'eighty', 'ninety'];

      s = s.toString();
      s = s.replace(/[\, ]/g, '');
      if (s != parseFloat(s))
        return 'NaN';
      
      var x_val = s.indexOf('.');
      if (x_val == -1)
        x_val = s.length;
      if (x_val > 15)
        return 'too big';
      
      var n_val = s.split('');
      var str_val = '';
      var sk_val = 0;
      
      for (var i = 0; i < x_val; i++) {
        if ((x_val - i) % 3 == 2) {
            if (n_val[i] == '1') {
              str_val += tn_val[Number(n_val[i + 1])] + ' ';
              i++;
              sk_val = 1;
            } 
            else if (n_val[i] != 0) {
              str_val += tw_val[n_val[i] - 2] + ' ';
              sk_val = 1;
            }
        } 
        else if (n_val[i] != 0) {
          str_val += dg_val[n_val[i]] + ' ';
          if ((x_val - i) % 3 == 0)
            str_val += 'hundred ';
          sk_val = 1;
        }
        if ((x_val - i) % 3 == 1) {
          if (sk_val)
            str_val += th_val[(x_val - i - 1) / 3] + ' ';
          sk_val = 0;
        }
      }
      
      if (x_val != s.length) {
        var y_val = s.length;
        str_val += 'point ';
        for (var i = x_val + 1; i < y_val; i++)
            str_val += dg_val[n_val[i]] + ' ';
      }
      return str_val.replace(/\s+/g, ' ');
    },

    async downloadBankSlip() {
      if (this.isDownloadingBankSlip) {
        return
      }

      this.isDownloadingBankSlip = true
      this.BankSlipProgress = 'Preparing...'

      try {
        await BankSlipGenerator.generateBankSlip(
          (message, progress) => {
            this.BankSlipProgress = message
          },
          (error) => {
            console.error('Bank Slip generation error:', error)
            this.$iziToast.error({
              title: 'Error',
              message: error.message || 'Failed to generate Bank Slip. Please try again.'
            })
          }
        )

        // Success notification
        this.$iziToast.success({
          title: 'Success',
          message: 'Bank Slip downloaded successfully!'
        })
      } catch (error) {
        console.error('Bank Slip download error:', error)
        this.$iziToast.error({
          title: 'Error',
          message: error.message || 'Failed to download Bank Slip. Please try again.'
        })
      } finally {
        this.isDownloadingBankSlip = false
        this.BankSlipProgress = 'Preparing...'
      }
    },

    async downloadSIF(){
      if (this.isDownloadingSIF) {
        return
      }

      this.isDownloadingSIF = true
      this.SIFProgress = 'Preparing...'

      try {
        await SifGenerator.generateSif(
          (message, progress) => {
            this.SIFProgress = message
          },
          (error) => {
            console.error('SIF generation error:', error)
            this.$iziToast.error({
              title: 'Error',
              message: error.message || 'Failed to generate SIF. Please try again.'
            })
          }
        )


        // Success notification
        this.$iziToast.success({
          title: 'Success',
          message: 'SIF downloaded successfully!'
        })
      } catch (error) {
        console.error('SIF download error:', error)
        this.$iziToast.error({
          title: 'Error',
          message: error.message || 'Failed to download SIF. Please try again.'
        })
      } finally {
        this.isDownloadingSIF = false
        this.SIFProgress = 'Preparing...'
      }
    },

    

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

  .is-blocked {
    border: 1px solid rgb(163, 13, 13) !important;
  }

  .is-danger {
    color: rgb(163, 13, 13) !important;
  }

.checkout-form select{
  padding: 10px 10px !important;
}

.form-check-input {
  appearance: auto !important;  /* restores default checkbox look */
  width: 1.1rem;                /* optional: keep Bootstrap size */
  height: 1.1rem;
}


.loader {
  margin-top: 20%;
}
.d-flex{
  padding:10px;
  margin:10px;
  -webkit-box-shadow: 1px 0 15px 2px #c1b3b3;
    box-shadow: 1px 0 15px 2px #c1b3b3;
}
.home-page {
  background: url(../../assets/bg.svg);
  background-size: cover;
  /*font-family: 'Poppins', sans-serif;*/
}

.form-group input:not([disabled]), 
.form-group select:not([disabled]),
.form-group textarea:not([disabled]) {
  background-color: white;   
}

.home-page section {
  padding: 5px 0px;
}

/* Header */


.img-fluid{
  max-width:100%;
}


/* advantages */
.advantages {
  -webkit-box-shadow: 0px 3px 10px 0px #dadada;
  -moz-box-shadow: 0px 3px 10px 0px #dadada;
  box-shadow: 0px 3px 10px 0px #dadada;
}

.main-img-logo {
  background: rgba(245, 222, 179, 0.5);
  margin: 4px;
  padding: 8px;
}

* {
   box-sizing: border-box;
}
.flower-spinner{
  margin: auto;
}

.responsive-center {
  margin: 20px 0; /* Default top-bottom margin for mobile */
}

/* Large devices (≥992px) */
@media (min-width: 992px) {
  .responsive-center {
    margin: 0 auto;   /* Center horizontally */
      /* Optional: prevents full width */
  }
}


/* Base outline button */
.btn-reload-outline {
  padding: 6px 20px;  /* wider */
  border-radius: 6px;
  font-weight: 500;
  transition: all 0.25s ease;
  border: 1px solid #6c757d;     /* outline */
  color: #6c757d;
  background-color: transparent; /* outline look */
}

/* Hover effect */
.btn-reload-outline:hover {
  background-color: #f1f1f1;
}

/* Loading state: looks like Bootstrap filled button */
.btn-reload-outline.loading {
  background-color: #6c757d !important;
  color: #fff !important;
  border-color: #6c757d !important;
  cursor: wait;
  opacity: 0.95;
}

/* Subtle pulse while loading */
.btn-reload-outline.loading {
  animation: pulse 0.9s infinite ease-in-out;
}

@keyframes pulse {
  0%   { transform: scale(1); }
  50%  { transform: scale(1.04); }
  100% { transform: scale(1); }
}



</style>